import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";

import { Grid } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "../../../components/UpdateUi/CustomeSelect";
import ToastModal from "views/components/ToastModal";
import { sortByString } from "utils/Utils";
import { deviationDataConfig } from "assets/properties/properties";
import { commonButton } from "assets/properties/properties";
import { toastAction } from "assets/properties/properties";
import { deviationRuleCode } from "assets/properties/properties";
import { deviationRuleUnitMap } from "assets/properties/properties";
import { handleOnlyNumberPointerAndNegative } from "utils/Utils";

const DeviationCreate = ({ classes }) => {
  const params = useParams();
  let navigate = useNavigate();
  const { createSuccess, button, emailError, mainUrl, updateUser, editLabel } =deviationDataConfig;
  const [designation, setDesignation] = useState("");
  const [designationErrorState, setdesignationErrorState] = useState(false);
  const [deviationCode, setDeviationCode] = useState("");
  const [level, setLevel] = useState("");
  const [deviationCodeError, setDeviationCodeError] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [redirectURL, setRedirectURL] = useState("");
  const [designationData, setDesignationData] = useState([]);
  const [minValue, setMinValue] = useState("");
  const [minValueError, setMinValueError] = useState(false);
  const [maxValue, setMaxValue] = useState("");
  const [maxValueError, setMaxValueError] = useState(false);
  const [deviationRule, setDeviationRule] = useState("");
  const [deviationUnitType, setDeviationUnitType] = useState("");
  const [isOverlap, setIsOverlap] = useState(false);
  const [deviationData, setDeviationData] = useState([]);
  const [editLoaded, setEditLoaded] = useState(false);
  useEffect(() => {
    getDesignationFindAll();
  }, []);
  useEffect(() => {
    if (params.id && !editLoaded) return;

    if (minValue && maxValue) {
      checkDuplicateRange(minValue, maxValue);
    }
  }, [deviationCode]);
  useEffect(() => {
    if (deviationCode && deviationRuleUnitMap[deviationCode]) {
      const { ruleType, unit } = deviationRuleUnitMap[deviationCode];
      setDeviationRule(ruleType);
      setDeviationUnitType(unit);
    }
  }, [deviationCode]);

  useEffect(() => {
    if (designation && designationData.length > 0) {
      const designationLevel = designationData.find(
        (item) => item.designation === designation
      )?.level;
      setLevel(designationLevel);
    }
  }, [designation, designationData]);

  const getDesignationFindAll = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.DESIGNATION_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data) {
      const sortedArray = sortByString(result?.data, "designation", true);
      setDesignationData(sortedArray);
        await deviationFindAll();
    }
  };

  const deviationFindAll = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.DEVIATION_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code || result?.data?.length === 0) {
      toastUpdate(
        "Error",
        result?.data?.user_description || "No Data Found",
        true
      );
      return;
    }
    setDeviationData(result.data);
    if(params.id){
      const selectedDeviation = result.data.find(
        (item) => Number(item.id) === Number(params.id)
        );
        if (selectedDeviation) {
          await deviationFindById(selectedDeviation);
      }
    }
  };

  const deviationFindById = async (getRuleTypeData) => {
    const result = await apiHandler({
      url: endpoint.DEVIATION_FIND_BY_RULE + getRuleTypeData?.code,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      setCallInProgress(false);
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      const getOriginalData = result?.data?.filter(
        (item) => Number(item.id) === Number(params.id)
      );
      setDesignation(getOriginalData?.[0]?.designation);
      setMinValue(getOriginalData?.[0]?.minValue);
      setMaxValue(getOriginalData?.[0]?.maxValue);
      setDeviationCode(getOriginalData?.[0]?.code);
      setIsActive(getOriginalData?.[0]?.active);
      setDeviationRule(getOriginalData?.[0]?.ruleType);
      setDeviationUnitType(getOriginalData?.[0]?.unit);
      setTimeout(() => {
        setEditLoaded(true);
      }, 100);
    }
  };

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const onChangeCheckbox = (e, type) => {
    const value = e.target.checked;
    setIsActive(value);
  };
  const checkDuplicateRange = (min, max) => {
if (params.id && !editLoaded) {
setIsOverlap(false);
return false;
}

if (deviationRule !== "RANGE") {
setIsOverlap(false);
return false;
}

const newMin = Number(min);
const newMax = Number(max);

const conflict = deviationData?.find((item) => {
if (item.code !== deviationCode) return false;
if (Number(item.id) === Number(params.id)) return false;

const existingMin = Number(item.minValue);
const existingMax = Number(item.maxValue);

return newMin < existingMax && newMax > existingMin;
});

if (conflict) {
setIsOverlap(true);

toastUpdate(
  "Error",
  `Range overlaps with existing range ${conflict.minValue} - ${conflict.maxValue}`,
  true
);

return true;
}

setIsOverlap(false);
return false;
};
  // validation for Edit Function
  const isValidated = () => {
    let isValid = true;
    if (!deviationCode) {
      setDeviationCodeError(true);
      isValid = false;
    } else {
      setDeviationCodeError(false);
    }
    if (!designation) {
      setdesignationErrorState(true);
      isValid = false;
    } else {
      setdesignationErrorState(false);
    }
    if (deviationRule === "RANGE") {
      if (minValue === "") {
        setMinValueError(true);
        isValid = false;
      } else {
        setMinValueError(false);
      }
      if (maxValue === "") {
        setMaxValueError(true);
        isValid = false;
      } else {
        setMaxValueError(false);
      }
      if (
        minValue !== "" &&
        maxValue !== "" &&
        Number(maxValue) < Number(minValue)
      ) {
        toastUpdate(
          "Error",
          "Max Value must be greater than or equal to Min Value",
          true
        );
        isValid = false;
      }
    } else {
      setMinValueError(false);
      setMaxValueError(false);
    }
    return isValid;
  };

  const createDeviation = async () => {
    if (isValidated()) {
      toastUpdate("", "", false);
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.DEVIATION_CREATE,
        method: "POST",
        authToken: authToken,
        data: {
          code: deviationCode,
          ruleType: deviationRule,
          unit: deviationUnitType,
          designation: designation,
          minValue: minValue,
          maxValue: maxValue,
          active: isActive,
          level:level,
          remarks: "",
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate(toastAction?.error, res?.data?.user_description, true);
        return;
      } else {
        toastUpdate(toastAction?.success, createSuccess, true);
        setRedirectURL(mainUrl);
      }
    } else {
      if (Number(minValue) > Number(maxValue)) {
        toastUpdate(
          "Error",
          "Min always greather then and equal to maxValue",
          true
        );
      }
    }
  };
  const editDeviation = async () => {
    if (isValidated()) {
      toastUpdate("", "", false);
      setCallInProgress(true);

      const res = await apiHandler({
        url: endpoint.DEVIATION_UPDATE + params?.id,
        method: "PUT",
        authToken: authToken,
        data: {
          code: deviationCode,
          ruleType: deviationRule,
          unit: deviationUnitType,
          designation: designation,
          minValue: minValue,
          maxValue: maxValue,
          active: isActive,
          level:level,
          remarks: "",
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate(toastAction?.error, res?.data?.user_description, true);
        return;
      } else {
        toastUpdate(toastAction?.success, updateUser, true);
        setRedirectURL(mainUrl);
      }
    } else {
      if (Number(minValue) > Number(maxValue)) {
        toastUpdate(
          "Error",
          "Min always greather then and equal to maxValue",
          true
        );
      }
    }
  };

  const handleCreateDeviation = async (event) => {
    if (params.id) {
      editDeviation();
    } else {
      createDeviation();
    }
  };
  // cancel button function
  const handlecanceluser = () => {
    navigate(mainUrl);
  };

  const title = params?.id ? editLabel : button;
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={title}
          button1={params?.id ? "Update" : commonButton?.button1}
          button2={commonButton?.button2}
          button1click={handleCreateDeviation}
          button2click={handlecanceluser}
          disabled1={
            isOverlap ||
            (deviationRule === "RANGE" &&
              (minValue === "" ||
               maxValue === "" ||
               Number(maxValue) < Number(minValue)))
          }
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Deviation Code*"
              id="master_type"
              error={deviationCodeError}
              value={deviationCode}
              setState={setDeviationCode}
              data={deviationRuleCode}
              setError={setDeviationCodeError}
              type="partnerName"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Designation*"
              error={designationErrorState}
              id="designationS"
              value={designation}
              setState={setDesignation}
              data={designationData}
              setError={setdesignationErrorState}
              type="designation"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Level"
              value={level}
              setState={setLevel}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Min Value"
              value={minValue}
              setState={(e) => handleOnlyNumberPointerAndNegative(e, setMinValue)}
              setBlur={(e) => { const newMin = e;
                  if (newMin !== "" && maxValue !== "") {
                    checkDuplicateRange(newMin, maxValue);
                  }
                }
              }
              error={minValueError}
              disabled={deviationRule !== "RANGE"}
              setError={setMinValueError}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Max Value"
              value={maxValue}
              setState={(e) => handleOnlyNumberPointerAndNegative(e, setMaxValue)}
              setBlur={(e) => { const newMax = e;
                if (minValue !== "" && newMax !== "") {
                  checkDuplicateRange(minValue, newMax);
                }}
              }
              error={maxValueError}
              disabled={deviationRule !== "RANGE"}
              setError={setMaxValueError}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <p style={{ fontWeight: "bold" }}>
              {" "}
              <input
                id="selectAll"
                type="checkbox"
                checked={isActive}
                className={classes.checkboxInput}
                onChange={(e) => onChangeCheckbox(e, "USER")}
                // disabled={viewPage}
              />{" "}
              Active
            </p>
          </Grid>
        </Grid>
      </Grid>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </Grid>
  );
};

DeviationCreate.propTypes = {
  classes: PropTypes.object,
};

export default DeviationCreate;
